import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import InputNumber from '../../../component/input/InputNumber';
import { useTranslation } from 'react-i18next';
import './SchemeSettingsDialog.scss';

const SchemeSettingsDialog = ({
    visible,
    onHide,
    onSave,
    initialRows = 5,
    initialColumns = 4,
}) => {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        rows: initialRows,
        columns: initialColumns,
    });

    useEffect(() => {
        if (visible) {
            setFormData({
                rows: initialRows,
                columns: initialColumns,
            });
        }
    }, [visible, initialRows, initialColumns]);

    const handleNumberChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value ?? prev[field],
        }));
    };

    const handleSave = () => {
        if (formData.rows < 1 || formData.columns < 1) return;

        onSave(formData);
        onHide();
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter') {
            handleSave();
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            className="scheme-settings-dialog"
            modal
            closable
            closeOnEscape
            draggable={false}
            resizable={false}
            showHeader={false}
        >
            <div className="scheme-settings-dialog__header">
                <h2>{t('planogram.schemeSettings.title')}</h2>

                <button
                    type="button"
                    className="scheme-settings-dialog__close"
                    onClick={onHide}
                    aria-label={t('common.close', 'Close')}
                >
                    <i className="pi pi-times" />
                </button>
            </div>

            <p className="scheme-settings-dialog__description">
                {t('planogram.schemeSettings.description')}
            </p>

            <div className="scheme-settings-dialog__fields">
                <div className="scheme-settings-dialog__field">
                    <label>{t('planogram.schemeSettings.rows')}</label>

                    <InputNumber
                        value={formData.rows}
                        onValueChange={event => handleNumberChange('rows', event.value)}
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        min={1}
                        max={20}
                        useGrouping={false}
                        className="scheme-settings-dialog__input"
                        onKeyDown={handleKeyDown}
                    />
                </div>

                <div className="scheme-settings-dialog__field">
                    <label>{t('planogram.schemeSettings.columns')}</label>

                    <InputNumber
                        value={formData.columns}
                        onValueChange={event => handleNumberChange('columns', event.value)}
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        min={1}
                        max={20}
                        useGrouping={false}
                        className="scheme-settings-dialog__input"
                        onKeyDown={handleKeyDown}
                    />
                </div>
            </div>

            <div className="scheme-settings-dialog__footer">
                <Button
                    label={t('planogram.schemeSettings.save')}
                    onClick={handleSave}
                    disabled={formData.rows < 1 || formData.columns < 1}
                    className="scheme-settings-dialog__save"
                />
            </div>
        </Dialog>
    );
};

export default SchemeSettingsDialog;